import React from 'react';
import DatasetExplorer from '../../components/dataset/DatasetExplorer';
import '../../styles/preview.css';

export default function PreviewDatasetPage() {
    return (
        <div className="preview-dashboard container-fluid py-4 bg-light" style={{ minHeight: '100vh' }}>
            {/* Using DatasetExplorer with Visualizations enabled */}
            {/* We can wrap it or just render it. DatasetExplorer handles its own layout mostly. 
                 But let's put it in a card style if needed or just full height. 
                 DatasetExplorer expects to be in a flex container if possible for scrolling.
             */}
            <div className="h-100 d-flex flex-column">
                <DatasetExplorer
                    sourceId="main"
                    visualizations={true}
                    customTitle="Dataset Explorer"
                    enableVersioning={false}
                />
            </div>
        </div>
    );
}
